<template>
  <v-container id="login-container" fill-height fluid>
    <v-row>
      <div class="strip-multi-colors magalu-header-position"></div>
    </v-row>
    <v-row align="center" justify="center">
      <v-col id="login-col" cols="12" md="8" class="text-center pa-0">
        <v-row class="ma-0">
          <v-col cols="12" md="6" id="landing-image">
          </v-col>
          <v-col cols="12" md="6" align-self="center">
            <div>
              <h1 class="mb-0" style="font-size: 28px">Bem-vindo ao</h1>
            </div>
            <div id="logo-tradelinks"></div>
            <div class="my-10">
              <span id="texto-login">acesse através do</span>
            </div>
            <div v-if="isAmbientePrdInterno || isAmbienteStg">
              <v-btn id="btn-sso-corp" color="primary" class="mb-5" large @click="loginSso">
                Login Corporativo
                <br />
                (SSO Corp)
              </v-btn>
            </div>
            <div v-if="isAmbientePrdExterno || isAmbienteStg">
              <v-btn id="btn-id-magalu" color="secundary" large @click="loginIdMagalu">
                <svg width="220" height="44" viewBox="80 0 44 44" fill="none">
                  <path d="M32.4178 15.0692C32.351 14.3446 31.9814 14 31.311 14H29.5337C28.9636 14 28.5616 14.2415 28.2588 14.759L23.9327 22.2759L19.9083 14.759C19.64 14.2415 19.2035 14 18.6334 14H16.7214C16.051 14 15.6814 14.3446 15.6146 15.0692L14.5077 28.8621C14.4409 29.621 14.8095 30 15.5143 30H17.6612C18.3316 30 18.7346 29.6554 18.768 28.9308L19.2379 21.2067L21.8202 26C22.0886 26.5174 22.525 26.759 23.0952 26.759H24.5706C25.1408 26.759 25.5438 26.5518 25.8456 26L28.7631 20.8621L29.0983 28.9308C29.1317 29.6554 29.5003 30 30.1717 30H32.4857C33.1905 30 33.5591 29.621 33.4923 28.8621L32.4188 15.0692H32.4178Z" fill="#0086FF"/>
                  <path d="M33.8439 32H14.1561C14.0699 32 14 32.1779 14 32.3974V33.6026C14 33.8221 14.0699 34 14.1561 34H33.8439C33.9301 34 34 33.8221 34 33.6026V32.3974C34 32.1779 33.9301 32 33.8439 32Z" fill="url(#paint0_linear_11073_128025)"/>
                  <defs>
                    <linearGradient id="paint0_linear_11073_128025" x1="14" y1="32.9998" x2="34" y2="32.9998" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FBE53B"/>
                      <stop offset="0.17" stop-color="#FF4F01"/>
                      <stop offset="0.35" stop-color="#FF14B3"/>
                      <stop offset="0.55" stop-color="#8000FF"/>
                      <stop offset="0.8" stop-color="#00C1FF"/>
                      <stop offset="1" stop-color="#17F036"/>
                    </linearGradient>
                  </defs>
                  <text x="280%" y="33%" dominant-baseline="middle" text-anchor="middle" fill="#0086FF">Login Fornecedor</text>
                  <text x="280%" y="73%" dominant-baseline="middle" text-anchor="middle" fill="#0086FF">(ID Magalu)</text>
                </svg>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <div class="strip-multi-colors magalu-footer-position"></div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { authKeycloak } from '../config/authKeycloak';
import { authIDMagalu } from '../config/authIdMagalu';

export default {
  name: 'Landing',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('implantacao', [
      'indAmbienteProdutivo',
    ]),
    isAmbientePrdInterno() {
      return this.indAmbienteProdutivo && window.location.host.includes('tradelinks-admin.magazineluiza');
    },
    isAmbientePrdExterno() {
      return this.indAmbienteProdutivo && window.location.host.includes('tradelinks.magazineluiza');
    },
    isAmbienteStg() {
      return !this.isAmbientePrdInterno && !this.isAmbientePrdExterno;
    },
  },
  methods: {
    loginSso() {
      authKeycloak.login();
    },
    loginIdMagalu() {
      authIDMagalu.login();
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
@import url('https://maas.mlcdn.com.br/fonts/magalu-textos/css/swap/family.css');

h1 {
  margin-bottom: 32px;
}
#logo-tradelinks {
  background-image: url(../assets/img/logo-trade-pq.png);
  background-repeat: no-repeat;
  background-size: cover;
  height: 63px;
  width: 258px;
  margin: 0 auto;
}
#landing-image {
  background-image: url(../assets/img/landing-page02.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-color: #0087fa;
  border-radius: 5px 0 0 5px;
  height: 500px;
  width: 529.37px;
}
#btn-sso-corp {
  width: 240px;
  font-family: MagaluTextos;
  font-weight: bold;
  text-transform: none;
  font-size: 15px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 5px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px;
}
#btn-id-magalu {
  width: 240px;
  border: 1px solid #0086FF;
  font-family: MagaluTextos;
  font-weight: bold;
  text-transform: none;
  font-size: 15px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 5px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px;
}
#login-container {
  background-color: #ededed
}
#login-col {
  background-color: #ffffff;
  border-radius: 5px;
  padding-top: 2em;
  padding-bottom: 4em;
  font-family: MagaluTextos;
  text-transform: none;
}
#texto-login:before, #texto-login:after {
    content: "";
    height: 1px;
    background-color: #000;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 18%;
    margin: 0 5px;
}
.strip-multi-colors {
    border-radius: 2px 2px 0 0;
    -moz-border-radius-topright: 2px;
    -moz-border-radius-topleft: 2px;
    height: 5px;
    background: #fcd000;
    background: -moz-linear-gradient(left, #fcd000 0, #ff8a00 17%, #ff253a 34%, #ff37a8 51%, #a400e1 67%, #0086ff 83%, #00d604 100%);
    background: -webkit-linear-gradient(left, #fcd000 0, #ff8a00 17%, #ff253a 34%, #ff37a8 51%, #a400e1 67%, #0086ff 83%, #00d604 100%);
    background: linear-gradient(to right, #fcd000 0, #ff8a00 17%, #ff253a 34%, #ff37a8 51%, #a400e1 67%, #0086ff 83%, #00d604 100%);
}
.magalu-header-position {
    position: fixed !important;
    top: 0 !important;
    width: 100% !important;
    position: fixed;
}
.magalu-footer-position {
    position: fixed !important;
    bottom: 0 !important;
    width: 100% !important;
    position: fixed;
}
</style>
